import React from 'react';
import * as M from '../Modules';
import StaticCard from '../StaticCard';

function AttentionGroup() {
  return (
    <section className="drm-final-group">
      <div className="drm-final-group-cols drm-final-group-cols--2">
        <StaticCard id="friction-flags" label="Payment Friction" className="drm-final-card--bare">
          <M.FrictionFlags density="md" />
        </StaticCard>
        <div className="drm-final-divider-v" />
        <StaticCard id="cash-impact-signals" label="What Can Impact Your Cash" className="drm-final-card--bare">
          <M.CashImpactSignals density="md" />
        </StaticCard>
      </div>
    </section>
  );
}

export default AttentionGroup;
